import { NICEPAY_PAYMENT_METHODS } from "@/lib/nicepay-payment";

export type PaymentProvider = "nicepay" | "toss";
export type PaymentMethod = "card" | "kakaopay" | "tosspay" | "transfer" | "vbank";
export type PendingPaymentMethod = PaymentMethod | "widget";

export function getPaymentProvider(): PaymentProvider {
  const value = process.env.NEXT_PUBLIC_PAYMENT_PROVIDER;
  if (!value || value === "nicepay") return "nicepay";
  if (value === "toss") return "toss";
  throw new Error("지원하지 않는 결제사 설정입니다.");
}

export function getPaymentMethods() {
  return getPaymentProvider() === "toss"
    ? [
        { id: "card", label: "신용/체크카드" },
        { id: "tosspay", label: "토스페이" },
        { id: "kakaopay", label: "카카오페이" },
        { id: "transfer", label: "계좌이체" },
        { id: "vbank", label: "무통장입금" },
      ] as const
    : NICEPAY_PAYMENT_METHODS;
}

export function isPaymentMethod(value: unknown): value is PaymentMethod {
  return getPaymentMethods().some((method) => method.id === value);
}

export function isPendingPaymentMethod(value: unknown): value is PendingPaymentMethod {
  return getPaymentProvider() === "toss" ? value === "widget" : isPaymentMethod(value);
}

export function isPaymentOrderId(value: unknown): value is string {
  return typeof value === "string" && /^[a-zA-Z0-9_-]{6,64}$/.test(value);
}

export function safePaymentReturnPath(value: unknown): string {
  if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//") || /[\\\u0000-\u0020\u007f]/.test(value)) return "/";
  return value;
}

export interface TossCheckout {
  paymentVariantKey: string;
  paymentDarkVariantKey?: string;
  isCulturalExpenses: boolean;
  clientKey: string;
  customerKey: string;
  orderId: string;
  orderName: string;
  amount: number;
  customerEmail: string;
  customerName: string;
  callbackToken: string;
}
